<div class="relative w-full">
  <!-- Trigger -->
  <button
    type="button"
    (click)="toggle()"
    [disabled]="isDisabled"
    [class.cursor-not-allowed]="isDisabled"
    [class.opacity-60]="isDisabled"
    class="w-full h-12 px-4 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg text-sm text-left
           flex items-center justify-between gap-2
           focus:outline-none focus:ring-1 focus:ring-gray-400 dark:focus:ring-slate-500 focus:border-gray-400 dark:focus:border-slate-500
           disabled:bg-gray-100 dark:bg-slate-700 disabled:cursor-not-allowed
           transition-colors hover:border-gray-400">

    <span [class]="selectedLabel ? 'text-gray-900 dark:text-white' : 'text-gray-400'">
      {{ selectedLabel || placeholder }}
    </span>

    <!-- Chevron -->
    <svg
      class="w-4 h-4 text-gray-400 flex-shrink-0 transition-transform duration-200"
      [class.rotate-180]="isOpen"
      xmlns="http://www.w3.org/2000/svg"
      fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  </button>

  <!-- Dropdown panel -->
  @if (isOpen) {
  <div
    class="dropdown-panel absolute z-50 mt-1 w-full bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg shadow-lg overflow-hidden">
    @if (searchable) {
    <div class="p-2 border-b border-gray-100 dark:border-slate-700">
      <input
        type="text"
        [value]="searchTerm"
        (input)="onSearchTermChange($event)"
        (click)="$event.stopPropagation()"
        [placeholder]="searchPlaceholder"
        class="w-full h-9 px-3 text-sm bg-gray-50 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded-md
               focus:outline-none focus:ring-1 focus:ring-gray-400 dark:focus:ring-slate-500" />
    </div>
    }
    <ul class="py-1 max-h-52 overflow-y-auto">
      @for (option of filteredOptions; track option.value) {
      <li>
        <button
          type="button"
          (click)="select(option)"
          class="w-full flex items-center justify-between px-4 py-2.5 text-sm text-left
                 transition-colors hover:bg-blue-50 dark:hover:bg-slate-700 hover:text-blue-700 dark:hover:text-blue-400"
          [ngClass]="{'bg-blue-50 dark:bg-slate-700': option.value === selectedValue, 'text-blue-700 dark:text-blue-400': option.value === selectedValue, 'font-semibold': option.value === selectedValue}">

          {{ option.label }}

          @if (option.value === selectedValue) {
          <svg class="w-4 h-4 flex-shrink-0" xmlns="http://www.w3.org/2000/svg"
               fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
          </svg>
          }
        </button>
      </li>
      } @empty {
      <li class="px-4 py-2.5 text-sm text-gray-400">No matches found</li>
      }
    </ul>
  </div>
  }
</div>
